import { FC } from 'react';

import RatioItem from './RatioItem';
import { RatioList } from './Wrapper';
import { switchFacebookCoverThumbToHorizontal } from './helpers';
import { VideoRatiosProps, VideoRatioItemProps } from './types';

type VideoRatioListProps = VideoRatiosProps & {
  list: VideoRatioItemProps[];
};

const VideoRatioList: FC<VideoRatioListProps> = ({
  list,
  ...ratioItemProps
}) => {
  const updatedList = switchFacebookCoverThumbToHorizontal(list);

  return (
    <RatioList>
      {updatedList.map(item => (
        <RatioItem key={item.displayName} {...{ item, ...ratioItemProps }} />
      ))}
    </RatioList>
  );
};

export default VideoRatioList;
